import type { PrefetchProps } from "@ui/lib/prefetch-context";
import { tv } from "@ui/lib/tv";
import { Link, type LinkProps } from "@ui/primitives/Link";
import type { ReactNode } from "react";

const card = tv({
  base: "relative flex w-full flex-col gap-3",
});

const DEFAULT_CARD_CACHE_FOR: [string, string] = ["1m", "5m"];

interface CardBaseProps {
  children?: ReactNode;
  className?: string;
}

interface CardWithLinkProps extends CardBaseProps, PrefetchProps {
  href: string;
  linkLabel: string;
  /** Fires when the card link is activated, before navigation. */
  onPress?: LinkProps["onPress"];
}

interface CardWithoutLinkProps extends CardBaseProps {
  href?: never;
  linkLabel?: never;
  onPress?: never;
  prefetch?: never;
  cacheFor?: never;
  cacheTags?: never;
}

export type CardProps = CardWithLinkProps | CardWithoutLinkProps;

export function Card({
  children,
  className,
  href,
  linkLabel,
  onPress,
  prefetch = "hover",
  cacheFor = DEFAULT_CARD_CACHE_FOR,
  cacheTags,
}: CardProps) {
  return (
    <div className={card({ className })}>
      {children}
      {href && (
        <Link
          aria-label={linkLabel}
          className="absolute inset-0"
          href={href}
          onPress={onPress}
          prefetch={prefetch}
          cacheFor={cacheFor}
          cacheTags={cacheTags}
        />
      )}
    </div>
  );
}
